import React from 'react';
import { useNavigate } from 'react-router-dom';
import Row from '../../../Common/Row';
import Col from '../../../Common/Col';
import Input from '../../../Common/HtmlTags/Input';
import Button from '../../../Common/HtmlTags/Button';
import LoadingIndicator from '../../../store/LoadingIndicator';
import { GoBack } from '../../../../containers/goBack/inedx';
import AdvancedUpload from '../../../store/AdanceFileUpload';
import AdvancedUploadHelper from '../../../store/AdanceFileUpload/updateFileUpload';
import Switch from '../../../store/Switch';
import { withRouter } from '../../../../withRouter';
import { connect } from 'react-redux';
import actions from '../../../../actions';
import { resolvePartnerLogo } from '../../../store/ResolveImage';

const EditPartnerLogoForm = (props) => {
  const {
    partnerLogo,
    editFormErrors,
    partnerLogoEditChange,
    updatePartnerLogo,
    deletePartnerLogo,
    isLoading,
    isLightMode,
  } = props;

  const navigate = useNavigate();

  const handleSubmit = (event) => {
    event.preventDefault();
    updatePartnerLogo(navigate);
  };

  const existingImageUrls = partnerLogo.imageUrl
    ? [resolvePartnerLogo(partnerLogo.imageUrl)]
    : [];

  return (
    <div className='add-event d-flex flex-column mb-custom-5em'>
      {isLoading && <LoadingIndicator isLightMode={isLightMode} />}
      <div
        style={{
          marginBottom: '-1em',
          justifyContent: 'space-between',
          padding: '0em 1em',
        }}
        className='d-flex team-members-header'
      >
        <h2 className={`${isLightMode ? 'p-black' : 'p-white'} font-size-25`}>
          Partner Logo Details
        </h2>
        <GoBack navigate={navigate} />
      </div>

      <form noValidate>
        <Row>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12' lg='6'>
            <Input
              type='text'
              error={editFormErrors.name}
              label='Name'
              name='name'
              placeholder='Enter partner name'
              value={partnerLogo.name || ''}
              onInputChange={partnerLogoEditChange}
            />
          </Col>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12' lg='6'>
            <label className='me-2'>Show on site</label>
            <Switch
              id='partner-logo-enabled-edit'
              checked={partnerLogo.isEnabled !== false}
              toggleCheckboxChange={(value) => partnerLogoEditChange('isEnabled', value)}
            />
          </Col>
          <Col className={`${isLightMode ? 'p-black' : 'p-white'}`} xs='12'>
            <h5>Replace Logo</h5>
            <AdvancedUpload
              error={editFormErrors.image}
              onFilesChange={(files) => partnerLogoEditChange('image', files)}
              imageLimit={10 * 1024 * 1024}
              videoLimit={0}
              limit={1}
              vLimit={0}
            />
            {existingImageUrls.length > 0 && (
              <>
                <h5 style={{ paddingTop: '1em' }}>Current Logo</h5>
                <AdvancedUploadHelper initialUrls={existingImageUrls} />
              </>
            )}
          </Col>
        </Row>
      </form>
      <Row>
        <div className='edit-event-actions'>
          <Button onClick={handleSubmit} style={{ padding: '10px 20px' }} text='Save Partner Logo' />
          <Button
            onClick={() => deletePartnerLogo(partnerLogo._id, navigate)}
            style={{ padding: '10px 20px' }}
            text='Delete Partner Logo'
          />
        </div>
      </Row>
    </div>
  );
};

class EditPartnerLogo extends React.PureComponent {
  componentDidMount() {
    this.props.resetPartnerLogo();
    const partnerLogoId = this.props.match.params.id;
    this.props.fetchPartnerLogo(partnerLogoId);
  }

  componentDidUpdate(prevProps) {
    if (this.props.match.params.id !== prevProps.match.params.id) {
      this.props.resetPartnerLogo();
      const partnerLogoId = this.props.match.params.id;
      this.props.fetchPartnerLogo(partnerLogoId);
    }
  }

  render() {
    return <EditPartnerLogoForm {...this.props} />;
  }
}

const mapStateToProps = (state) => ({
  partnerLogo: state.partnerLogos.partnerLogo,
  editFormErrors: state.partnerLogos.editFormErrors,
  isLoading: state.partnerLogos.isLoading,
  isLightMode: state.dashboard.isLightMode,
});

export default connect(mapStateToProps, actions)(withRouter(EditPartnerLogo));
